import React, { useState } from 'react'
import { minimumPriceValidator, minimumPriceValidatorInviteOnly } from 'modules/utils/validators'
import { Form, Input, InputNumber, Switch } from 'antd'

import './index.styl'
import SingleDatePicker from '../../../../Header/DetailsFields/SingleDatePicker'
import TooltipInfo from '../../../../../../CreateEventV2/TooltipInfo'

const { Item } = Form

const GeneralAdmissionItems = ({ namePrefix, currentEventDetails, categoryData, form }) => {
  const [isEarlyBird, setIsEarlyBird] = useState(categoryData?.hasEarlyBird || false)
  const [earlyBirdDate, setEarlyBirdDate] = useState(categoryData?.earlyBirdDate || '')
  const [availableTicket, setAvailableTicket] = useState(form.getFieldValue('showAvailableTickets') || false)
  const [isReserved, setIsReserved] = useState(namePrefix !== 0 && (categoryData?.isReserved || categoryData?.privacyOption === 'invite' || false))
  const isFirstCategory = namePrefix === 0

  const availableTicketHandler = () => {
    setAvailableTicket(!availableTicket)
    // form.setFieldsValue({
    //  showAvailableTickets: !availableTicket,
    // })
  }
  const onCheckEarlyBird = () => setIsEarlyBird(!isEarlyBird)
  const onCheckReserved = () => {
    const newIsReserved = !isReserved
    setIsReserved(newIsReserved)
    if (newIsReserved) {
      form.setFields([{ name: ['generalAdmission', namePrefix, 'name'], value: 'Reserved' }])
    }
  }
  return (
    <>
      <div className='topField generalAdmissionItemsWrapper'>
        <div className='inputFields'>
          <Item
            rules={[{ required: true, message: 'Enter Ticket Category Name' }]}
            name={[namePrefix, 'name']}
            label='Ticket Category Name'
            initialValue={namePrefix === 0 ? 'General Admission' : ''}
          >
            <Input className='inputName' />
          </Item>
          <div className='priceQuantityWrapper'>
            <div className='mobileFlex'>
              <Item
                name={[namePrefix, 'price']}
                label='Ticket Price'
                rules={[
                  { required: true, message: 'Enter price' },
                  isReserved ? minimumPriceValidatorInviteOnly : minimumPriceValidator,
                ]}
              >
                <InputNumber placeholder='0' className='price' min={0} />
              </Item>
              <Item
                rules={[
                  { required: true, message: 'Enter quantity' },
                  { type: 'number', max: 100000, message: 'Quantity cannot exceed 100 000' },
                  {
                    validator: (_, value) =>
                      Number.isInteger(value) ? Promise.resolve() : new Promise((resolve, reject) => {
                        reject(new Error('Quantity must be an integer!'))
                      }),
                  },
                ]}
                name={[namePrefix, 'quantity']}
                label='Tickets Quantity'
              >
                <InputNumber
                  className='quantity'
                  placeholder='0'
                  min={0}
                  step={1}
                />
              </Item>
            </div>
          </div>
        </div>
      </div>
      <div className='availableAndReservedRow'>
        <div className='radioItemField'>
          <Item
            name={[namePrefix, 'showAvailableTickets']}
            valuePropName='checked'
            className='item'
            initialValue={availableTicket}
          >
            <Switch onChange={availableTicketHandler} defaultChecked={availableTicket} />
          </Item>
          <div className='text'>Show available tickets</div>
        </div>
        {!isFirstCategory &&
          <div className='radioItemField reservedField'>
            <Item
              name={[namePrefix, 'isReserved']}
              valuePropName='checked'
              className='item'
              initialValue={isReserved}
            >
              <Switch onChange={onCheckReserved} defaultChecked={isReserved} />
            </Item>
            <TooltipInfo
              className='privacyLabel'
              text='Reserved'
              info='The only way to distribute Reserved tickets is by Gifting or Direct Sale'
            />
          </div>}
      </div>
      <div className='radioItemField earlyBirdDateItem'>
        <Item
          name={[namePrefix, 'hasEarlyBird']}
          className='item'
          valuePropName='checked'
        >
          <Switch onChange={onCheckEarlyBird} defaultChecked={isEarlyBird} />
        </Item>
        <div className='text'>Early Bird Special</div>
      </div>
      {isEarlyBird && (
        <div className='earlyBirdFieldsWrapper'>
          <SingleDatePicker label='Early Bird' namePrefix={namePrefix} nameText='earlyBirdDate' fromDate={earlyBirdDate} form={form} setFromDate={setEarlyBirdDate} title='Early Bird Date' />
          <Item
            name={[namePrefix, 'earlyBirdPrice']}
            dependencies={[[namePrefix, 'price']]}
            label='Price'
            rules={[
              { required: true, message: 'Enter price' },
              minimumPriceValidator,
            ]}
            className='earlyBirdPrice'
          >
            <InputNumber placeholder='0' min={0} />
          </Item>
        </div>
      )}
    </>
  )
}

export default GeneralAdmissionItems
